import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASE_FRAGMENT } from '../fragments'

const INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASES_QUERY = gql`
  query ingredientCommonNegativeSynonymPhrases {
    ingredientCommonNegativeSynonymPhrases {
      results {
        ...IngredientCommonNegativeSynonymPhraseFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASE_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASES_QUERY
